export default __webpack_public_path__ + "static/media/logotype-primary.0b210069.svg";